export const EXTERNAL_URLS = {
  lawfullyProLandingPage: 'https://lawfully.com/pro',
  awsApiGatewayFetchingHmac: 'https://xpior5x790.execute-api.us-east-1.amazonaws.com/default/generate-intercom-hmac',
  caseInquiry: 'https://egov.uscis.gov/e-request/onpt',
  caseStatusOnline: 'https://egov.uscis.gov/',
  myUscis: 'https://my.uscis.gov/',
  googlePrivacyPolicy: 'https://policies.google.com/privacy',
  lawfullyLogo: 'https://web-static-resources.lawfully.com/lawfully-logo.svg',
  lawfullyProFullLogo: 'https://web-static-resources.lawfully.com/lawfully-pro-full-logo.svg',
  lawfullyProFullLogoDark: 'https://web-static-resources.lawfully.com/lawfully-pro-full-logo-dark.svg',
}
